import { render, staticRenderFns } from "./trans.vue?vue&type=template&id=1aba04fe&scoped=true&"
import script from "./trans.vue?vue&type=script&lang=js&"
export * from "./trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba04fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aba04fe')) {
      api.createRecord('1aba04fe', component.options)
    } else {
      api.reload('1aba04fe', component.options)
    }
    module.hot.accept("./trans.vue?vue&type=template&id=1aba04fe&scoped=true&", function () {
      api.rerender('1aba04fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trans.vue"
export default component.exports